import * as PIXI from 'pixi.js'
import Matter from 'matter-js'
import { assets, containers, linesNum, matterAssets } from './gameUI.js'
// import { app } from "./appPixi.js";
import { pixiApp } from './initializePixi.js'
import { ballAndPointsNewRadius, boxNewWidth, fontSize, pointsPerRow, splitGradientTexture } from './utility.js'
import { settings } from '../settings.js'
import { startGameTicker, stopGameTicker } from './gameLogic.js'
import { lte } from 'lodash'
import { getPlinkoPointTints, isCompactPlinkoTheme } from '../../theme/plinkoTheme.config'
import { setupMatterJS } from './appMatter.js'
// import { setTickerRun } from './gameLogic.js'

// const pointRadiusInitial = 20
const pointsContainerWidthOffset = 1
export let gapX = 0
export const createPointsAndBoxes = () => {
  if (!matterAssets.world || !matterAssets.engine) {
    setupMatterJS()
  }
  const lineNum = linesNum.get()
  const gapY = pixiApp?.app.screen.height / (lineNum + 1 + pointsContainerWidthOffset) - 10
  gapX = pixiApp?.app.screen.width / (pointsPerRow[lineNum - 1]) + 4 // gapY * 0.96
  const pointRadius = ballAndPointsNewRadius(lineNum)
  for (let row = 0; row < lineNum; row++) {
    const startX = (pixiApp?.app.screen.width - (row * gapX) - gapX * 2) / 2
    const rowArray = []
    for (let j = 0; j < pointsPerRow[row]; j++) {
      const point = createAPoint({ x: startX + (j * gapX), y: gapY * (row + 1 + pointsContainerWidthOffset), radius: pointRadius, pointRow: row, pointNumber: j })
      point.destroy = function () {
        const index = rowArray.indexOf(this)
        if (index !== -1) {
          rowArray.splice(index, 1)
          if (this.pixiBody) {
            containers.pointsContainer?.removeChild(this.pixiBody)
            this.pixiBody.destroy({ children: true })
            this.pixiBody = null
          }
          if (this.matterBody && matterAssets.world) {
            Matter.World.remove(matterAssets.world, this.matterBody)
            this.matterBody = null
          }
        }
      }

      rowArray.push(point)
    }

    if (row === lineNum - 1) { createBoxes(startX, gapX, 1715, lineNum) }

    assets.points.push(rowArray)
  }
}

function createBoxes(startX, gapX, y, lineNum) {
  const gradientSprites = splitGradientTexture(lineNum + 1)
  const boxWidth = boxNewWidth(lineNum)
  for (let i = 0; i < lineNum + 1; i++) {
    // const box = createABox(startX + (gapX * 0.5) + (gapX * i), y, boxWidth, settings.box.height, i, gradientSprites[i], lineNum)
    const box = createABox({ x: startX + (gapX * 0.5) + (gapX * i), y, width: boxWidth, height: settings.box.height, boxIndex: i, boxSprite: gradientSprites[i], lineNum, gapX })

    box.destroy = function () {
      const index = assets.boxes.indexOf(this)
      if (index !== -1) {
        assets.boxes.splice(index, 1)
        if (this.boxContainer) {
          containers.pointsContainer?.removeChild(this.boxContainer)
          this.boxContainer.destroy({ children: true })
          this.boxContainer = null
        }
        this.boxPixi = null
        this.boxText = null
        if (this.boxMatter && matterAssets.world) {
          Matter.World.remove(matterAssets.world, this.boxMatter)
          this.boxMatter = null
        }
      }
    }

    assets.boxes.push(box)
  }
  changePayoutText()
}

function createABox({ x, y, width, height, boxIndex, boxSprite, lineNum }) {
  const isThemeTwo = isCompactPlinkoTheme()
  const boxW = isThemeTwo ? (width * 2.5) : width * 2
  const boxH = isThemeTwo ? (height * 1.15) : height
  const physicsW = width

  const boxMatter = Matter.Bodies.rectangle(x, y, physicsW, boxH, {
    isStatic: true,
    collisionFilter: {
      category: 0x0003,
      mask: 0x0002
    },
    label: 'Box',
    boxIndex: boxIndex
  })

  if (!matterAssets.world || !matterAssets.engine) {
    setupMatterJS()
  }
  if (matterAssets.world) {
    Matter.World.add(matterAssets.world, boxMatter)
  }

  const boxContainer = new PIXI.Container()
  containers.pointsContainer.addChild(boxContainer)
  if (isCompactPlinkoTheme()) {
    const compactBoxWidth = gapX * 0.676
    boxContainer.x = x - compactBoxWidth / 2
  } else {
    boxContainer.x = x - width
  }
  boxContainer.y = y - height / 2 + 60
  boxContainer.startPos = boxContainer.y

  boxContainer.doNothing = () => { }
  boxContainer.boxState = boxContainer.doNothing

  boxContainer.boxBounceEffect = (delta) => {
    if (boxContainer.y > boxContainer.startPos) {
      boxContainer.y -= delta * settings.box.boxSpeed
    } else {
      boxContainer.y = boxContainer.startPos
      boxContainer.boxState = boxContainer.doNothing
    }
  }

  const boxGraphics = boxSprite
  boxGraphics.width = isCompactPlinkoTheme() ? gapX * 0.676 : width * 2
  boxGraphics.height = height

  if (isCompactPlinkoTheme()) {
    const maskGraphics = new PIXI.Graphics()
    maskGraphics.beginFill(0xffffff)
    maskGraphics.drawRoundedRect(0, 0, boxGraphics.width, boxGraphics.height, 9)
    maskGraphics.endFill()
    boxContainer.addChild(maskGraphics)
    boxGraphics.mask = maskGraphics
  }

  boxContainer.addChild(boxGraphics)
  const multiplierText = new PIXI.Text(
    '0.0x',
    new PIXI.TextStyle({
      fill: [isThemeTwo ? '#00091A' : '#ffffff'],
      fontFamily: isThemeTwo ? 'Barlow, sans-serif' : 'Arial',
      fontSize: fontSize(lineNum),
      fontWeight: isThemeTwo ? '800' : '750',
      letterSpacing: 0,
      align: 'center'
    })
  )

  multiplierText.x = boxGraphics.width / 2
  multiplierText.y = boxGraphics.height / 2
  multiplierText.scale.set(isThemeTwo ? 0.8 : 0.7, 1)
  multiplierText.anchor.set(0.5)
  boxContainer.addChild(multiplierText)

  return { boxMatter: boxMatter, boxContainer: boxContainer, boxPixi: boxGraphics, boxText: multiplierText }
}

let _payout = []
export const payoutText = {
  get: () => _payout,
  set: (newPayout) => { _payout = newPayout }
}

function changePayoutText() {
  const payout = payoutText.get()
  for (let i = 0; i < payout?.length; i++) {
    if (payout[i] || payout[i] === 0) {
      if (assets.boxes[i]) {
        const multiplierText = assets.boxes[i].boxText
        multiplierText.text = payout[i] + 'x'
      }
    } else console.error('Sent payout is not a valid number')
  }
}

export function setupPayoutText(payout) {
  return new Promise((resolve, reject) => {
    payoutText.set(payout)
    changePayoutText()
    resolve()
  })
}

export function changeLinesNumber(lineNum, payouts) {
  console.log('lineNum, payouts', lineNum, payouts)
  destroyAllPoints()
    .then(() => destroyAllBoxes())
    .then(() => {
      linesNum.set(lineNum)
      setupPayoutText(payouts)
    })
    .then(() => { createPointsAndBoxes() })
    .catch()
}

function createAPoint({ x, y, radius, pointRow, pointNumber }) {
  return {
    matterBody: pointMatter(x, y, radius, pointRow, pointNumber),
    pixiBody: pointPixi(x, y, radius)
  }
}

function pointMatter(x, y, radius, pointRow, pointNumber) {
  const point = Matter.Bodies.circle(x, y, radius, {
    isStatic: true,
    density: 1, // 10000
    collisionFilter: {
      category: 0x0001,
      mask: 0x0002
    },
    label: 'Point',
    pointRow: pointRow,
    pointNumber: pointNumber
  })
  if (!matterAssets.world || !matterAssets.engine) {
    setupMatterJS()
  }
  if (matterAssets.world) {
    Matter.World.add(matterAssets.world, point)
  }
  return point
}

function pointPixi(x, y, radius) {
  const isCompact = isCompactPlinkoTheme()
  console.log('pointPixi loading pins. isCompact:', isCompact)
  let point
  const pointTints = getPlinkoPointTints()

  if (isCompact) {
    point = new PIXI.Graphics()
    point.beginFill(pointTints.point)
    point.drawCircle(0, 0, radius)
    point.endFill()
    point.x = x
    point.y = y
  } else {
    const pointTex = PIXI.Assets.get('point_classic')
    if (pointTex) {
      point = new PIXI.Sprite(pointTex)
      point.anchor.set(0.5)
      point.x = x
      point.y = y
      point.width = radius * 2.5
      point.height = radius * 2.5
      point.tint = pointTints.point
    } else {
      point = new PIXI.Graphics()
      point.beginFill(pointTints.point)
      point.drawCircle(0, 0, radius)
      point.endFill()
      point.x = x
      point.y = y
    }
  }

  const shineAsset = PIXI.Assets.get('shineEffect')
  const shineFrames = shineAsset?.animations?.frames || shineAsset?.animations?.['shineEffect'] || (shineAsset?.textures ? Object.values(shineAsset.textures) : null)

  if (shineFrames && shineFrames.length > 0) {
    point.shine = new PIXI.AnimatedSprite(shineFrames)
    point.shine.scale.set(isCompact ? 1.2 : 9) // 1
    point.shine.alpha = 0.3 // 0.55
    point.shine.tint = pointTints.shine
    point.shine.animationSpeed = settings.points.shine?.animationSpeed || 0.7
    point.shine.visible = false
    point.startShine = () => {
      if (isCompact) {
        point.tint = 0xFFEA00
      }
      point.shine.play()
      point.shine.visible = true
    }
    point.shine.onLoop = () => {
      point.shine.gotoAndStop(1)
      point.shine.visible = false
      if (isCompact) {
        point.tint = 0xFFFFFF
      }
    }

    point.shine.anchor.set(0.5)
    point.addChild(point.shine)
  } else {
    point.shine = null
    point.startShine = () => {
      if (isCompact) {
        point.tint = 0xFFEA00
        setTimeout(() => {
          point.tint = pointTints.point || 0xFFFFFF
        }, 200)
      }
    }
  }

  containers.pointsContainer.addChild(point)

  return point
}

export const destroyAllPoints = () => {
  return new Promise((resolve, reject) => {
    // stopGameTicker()
    for (let pointArray = assets.points.length - 1; pointArray >= 0; pointArray--) {
      for (let point = assets.points[pointArray].length - 1; point >= 0; point--) {
        assets.points[pointArray][point].destroy()
      }
    }
    assets.points = []
    // startGameTicker()
    resolve()
  })
}

export const destroyAllBoxes = () => {
  return new Promise((resolve, reject) => {
    // stopGameTicker()
    let i = assets.boxes.length - 1
    while (i >= 0) {
      const box = assets.boxes[i]
      box.destroy()
      i--
    }
    assets.boxes = []
    // startGameTicker()
    resolve()
  })
}
